import BaseNodeQueue from './BaseNodeQueue';
import { SHAP_TYPE , EFFECT_TAG }  from '../../enums/index';

/**
* 基础节点的链表
*/
class CircleNodeQueue extends BaseNodeQueue {
  constructor(props) {
    super(props);

    this.circleInfoList = null;
  }

  // 设置详细信息 主要服务于每条线不一样灯珠数
  setCircleInfoList(circleInfoList) {
    // console.log('circleInfoList', circleInfoList);
    
    this.circleInfoList = circleInfoList;
    // if (Array.isArray(circleInfoList)) {
    //   this.circleInfoList = circleInfoList;
    // } else {
    //   this.circleInfoList = null;
    // }
  }
}

export default CircleNodeQueue;